<div *ngIf="items && items.length && items[0].content" [innerHtml]="items[0].content | sanitizeHtml: 'HTML' "> </div>